export const appKey = 'zsnUcDDogFWcrOEd'
export const version = '5.1.0'
export const salt = 'xmorL5QtWBjwSGxE'
